import React, { Component } from "react";
import "./CustomOption.css";

class CustomOption extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let listItem =
      this.props.placeholderOptions &&
      this.props.placeholderOptions.map((item, index) => (
        <li
          onClick={(e) => this.props.setSelectedOption(item)}
          key={item.idRjesenja}
          className={"rdw-dropdownoption-default placeholder-li"}
          id={"id" + item.idRjesenja}
        >
          {item.idRjesenja == null ? (
            <b>{item.nazivRjesenja}</b>
          ) : (
            item.nazivRjesenja
          )}
        </li>
      ));

    let defaultValueFiltered =
      this.props.placeholderOptions &&
      this.props.placeholderOptions.filter(
        (x) => x.idRjesenja == this.props.defaultValue
      );
    let defaultValueStr =
      defaultValueFiltered && defaultValueFiltered.length > 0
        ? defaultValueFiltered[0].nazivRjesenja
        : this.props.selectedOption.nazivRjesenja;
    return (
      <>
        <div
          onClick={this.props.openPlaceholderDropdown}
          className="rdw-block-wrapperx"
          aria-label="rdw-block-control"
          ref={this.props.ref}
        >
          <div
            className="rdw-dropdown-wrapper rdw-block-dropdown"
            aria-label="rdw-dropdown"
          >
            <div className="rdw-dropdown-selectedtext" title="Predlošci">
              <span>{defaultValueStr}</span>
              <div
                className={`rdw-dropdown-caretto${
                  this.props.placeholderDropdownOpened ? "close" : "open"
                }`}
              ></div>
            </div>
            <ul
              className={`rdw-dropdown-optionwrapper ${
                this.props.placeholderDropdownOpened ? "" : "placeholder-ul"
              }`}
              id="parentDropdownElement"
            >
              {listItem}
            </ul>
          </div>
        </div>
        <div className="rdw-btn" style={{ marginLeft: "5px" }}>
          <button
            onClick={this.props.saveTemplate(
              this.props.selectedOption.idRjesenja
            )}
          >
            Spremi predložak
          </button>
        </div>
        <div className="rdw-btn" style={{ marginLeft: "5px" }}>
          <button onClick={this.props.showDeleteTemplateModal}>
            Brisanje predložaka
          </button>
        </div>
      </>
    );
  }
}

export default CustomOption;
